import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from '@/App.vue'
import router from '@/router/router'
import store from '@/store/store'
import i18n from '@/plugins/i18n/i18n'

import VuePluginInitializer from '@/plugins/vue-plugin-initializer'
import HowlerService from '@/howler/Howler.service'
import { initMixin } from '@/mixin'

VuePluginInitializer.init()

const howlerService = new HowlerService(0)
initMixin(howlerService)

Vue.config.productionTip = false

Vue.use(VueMeta)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
